function percent(percent) {
  return Math.round(percent * 100) + '%'
}

export default percent
